import React from "react"

import { BottonbarContainer } from "./styles"

function Bottonbar(){

    return (
        <>
            <BottonbarContainer>
                <p>&copy; 2020 Rosana Rezende</p>
            </BottonbarContainer>
        </>
    )
}

export default Bottonbar